module.exports = __webpack_public_path__ + "img/12228_28.de1c55ef.png";